import {validate as validateEmail} from 'email-validator'

export function isValidEmail(email: string): boolean {
    return validateEmail(email)
}
